export default __webpack_public_path__ + "static/media/lampBedroomOn.34c14422.png";